// extracted by mini-css-extract-plugin
module.exports = {"pageDivider":"styles_pageDivider__24DX4"};